import common from 'shared/styles'

const styles = () => {
    return { button: common.stepsPictureButton }
}

export default styles
